'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _reactLoader = require('react-loader');

var _reactLoader2 = _interopRequireDefault(_reactLoader);

var _config = require('config');

var _config2 = _interopRequireDefault(_config);

var _search = require('redux/modules/search');

var searchActions = _interopRequireWildcard(_search);

var _components = require('../../components');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FundTargetDateLinks = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    result: state.fundsByStrategy.result,
    searching: state.fundsByStrategy.loading,
    searched: state.fundsByStrategy.loaded,
    error: state.fundsByStrategy.error
  };
}, searchActions), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(FundTargetDateLinks, _Component);

  function FundTargetDateLinks(props) {
    (0, _classCallCheck3.default)(this, FundTargetDateLinks);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FundTargetDateLinks.__proto__ || (0, _getPrototypeOf2.default)(FundTargetDateLinks)).call(this, props));

    _this.state = {};
    return _this;
  }
  //


  (0, _createClass3.default)(FundTargetDateLinks, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
      this.props.getFundsByStrategy([this.props.strategyName]);
    }
    //

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.TargetDateLinks, { funds: this.props.result, strategyName: this.props.strategyName });
    }
  }]);
  return FundTargetDateLinks;
}(_react.Component), _class2.propTypes = {
  searching: _react.PropTypes.bool,
  searched: _react.PropTypes.bool,
  error: _react.PropTypes.object,
  result: _react.PropTypes.array,
  // search: PropTypes.func,
  strategyName: _react.PropTypes.string.isRequired
}, _temp)) || _class);
exports.default = FundTargetDateLinks;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/core/FundTargetDateLinks/FundTargetDateLinks.js
// module id = 1326
// module chunks = 0